import request from '@/utils/request'
import consts from '@/utils/consts.js';
import { getStore } from '@/utils/storage.js';
export default {

  // 登录
  login: function (userId, password) {
    return request({
      url: '/mall/user/login',
      method: 'post',
      params: {
        'userId': userId,
        'password': password
      }
    })
  },


  // 登出系统
  logout: function () {
    return request({
      url: '/mall/user/logOut',
      method: 'post',
      params: {}
    })
  },

  // 邮箱点击进入找回密码校验链接是否有效
  checkfindPassCode: function (id, code) {
    return request({
      url: '/mall/user/checkPassCode',
      method: 'post',
      params: {
        id:id,
        code:code
      }
    })
  },

  // 申请找回密码
  findPassWord: function (userId, email) {
    return request({
      url: '/mall/user/sendPassCode',
      method: 'post',
      params: {
        userId:userId,
        email:email
      }
    })
  },

  // 找回密码-设置密码(未登录情况下)
  resetPassWord: function (id, password) {
    return request({
      url: '/mall/user/findPassWord',
      method: 'post',
      params: {
        id:id,
        pass:password
      }
    })
  },

  // 邮箱点击进入邮箱验证链接是否有效
  checkVerifyEmailCode: function (id, code) {
    return request({
      url: '/mall/user/checkEmailCode',
      method: 'post',
      params: {
        id:id,
        code:code
      }
    })
  },

  // 检查用户是否存在
  checkUser: function () {
    return request({
      url: '/mall/user/getSessionStatus',
      method: 'post',
      params: {}
    })
  },


  // 分公司管理员代替登录
  branchProxyLogin: function (sign, userId, token) {
    return request({
      url: '/mall/branch/login',
      method: 'post',
      params: {
        sign: sign,
        userId: userId,
        token:token
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/login.js